var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox',{attrs:{"val":_vm._val,"checked":_vm.chackboxVal},on:{"change":_vm.handleChange}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }